import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ProtocolSectionHttpEditRequestModel } from '../httpQueue/protocolSection/types';
import { ProtocolSectionOutDto } from 'shared/dtos/out/protocolSection';

export class ProtocolSectionEditor {
  constructor(
    private addRequest: (
      request: ProtocolSectionHttpEditRequestModel
    ) => Promise<any>
  ) {}

  async execute(
    inspectionId: string,
    sectionId: string,
    protocolSectionOutDto: ProtocolSectionOutDto,
    uniqueId: string,
    projectId: string
  ): Promise<void> {
    debugLog(
      'ProtocolSectionEditor',
      inspectionId,
      sectionId,
      protocolSectionOutDto
    );
    const request: ProtocolSectionHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionId,
        sectionId,
        protocolSectionOutDto,
        uniqueId,
        projectId,
      },
      entityType: HttpRequestModelType.protocolSection,
      status: HttpRequestStatus.NEW,
      url: `/project/${projectId}/inspection/${inspectionId}/section/${sectionId}`,
    };

    await this.addRequest(request);
  }
}

export const protocolSectionEditor = new ProtocolSectionEditor(addRequest);
